// components/confirmVpnModal.jsx
// Модалка-предупреждение про VPN перед оплатой заказа.
// Использование (внутри async-функции):
//   const ok = await confirmVpnModal();
//   if (!ok) return;
//
// Промис резолвится true («Продолжить») или false (Отмена / Esc / клик по фону).
// Кнопка «Продолжить» активна только после галочки «Я ознакомлен(а)».

import { useEffect, useState } from "react";
import { createRoot } from "react-dom/client";   // React 18. На React 17 см. примечание внизу файла.

const RED = "#d32f2f";

function VpnConfirmDialog({ onResult }) {
  const [agreed, setAgreed] = useState(false);
  const [shown, setShown]   = useState(false);

  useEffect(() => {
    const raf = requestAnimationFrame(() => setShown(true));   // плавное появление
    const onKey = (e) => { if (e.key === "Escape") onResult(false); };
    document.addEventListener("keydown", onKey);
    const prevOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      cancelAnimationFrame(raf);
      document.removeEventListener("keydown", onKey);
      document.body.style.overflow = prevOverflow;
    };
  }, [onResult]);

  return (
    <div
      onMouseDown={(e) => { if (e.target === e.currentTarget) onResult(false); }}
      style={{
        position: "fixed", inset: 0, zIndex: 100000,
        background: "rgba(0,0,0,0.55)",
        display: "flex", alignItems: "center", justifyContent: "center",
        padding: 16,
        opacity: shown ? 1 : 0,
        transition: "opacity 0.18s ease",
        WebkitTapHighlightColor: "transparent",
      }}
    >
      <div
        role="dialog"
        aria-modal="true"
        style={{
          width: "100%", maxWidth: 440,
          background: "#fff", borderRadius: 18,
          boxShadow: "0 20px 60px rgba(0,0,0,0.35)",
          padding: 24,
          transform: shown ? "translateY(0) scale(1)" : "translateY(8px) scale(0.98)",
          transition: "transform 0.2s cubic-bezier(0.22,1,0.36,1)",
        }}
      >
        <div style={{ fontSize: 20, fontWeight: 800, color: RED, marginBottom: 12 }}>
          Внимание
        </div>

        <div style={{ fontSize: 15, lineHeight: 1.5, color: "#222", marginBottom: 20 }}>
          Перед оплатой заказа рекомендуем{" "}
          <b style={{ color: RED }}>отключить VPN</b>, чтобы избежать возможных
          проблем с проведением платежа!
        </div>

        <label
          style={{
            display: "flex", alignItems: "center", gap: 10,
            fontSize: 15, color: "#222", cursor: "pointer",
            userSelect: "none", marginBottom: 22,
          }}
        >
          <input
            type="checkbox"
            checked={agreed}
            onChange={(e) => setAgreed(e.target.checked)}
            style={{ width: 20, height: 20, accentColor: RED, cursor: "pointer", flexShrink: 0 }}
          />
          Я ознакомлен(а)
        </label>

        <div style={{ display: "flex", gap: 12, justifyContent: "flex-end" }}>
          <button
            type="button"
            onClick={() => onResult(false)}
            style={{
              padding: "10px 18px", borderRadius: 12, border: "none",
              background: "#eceff1", color: "#333", fontSize: 15, fontWeight: 600,
              cursor: "pointer",
            }}
          >
            Отмена
          </button>
          <button
            type="button"
            onClick={() => agreed && onResult(true)}
            disabled={!agreed}
            style={{
              padding: "10px 22px", borderRadius: 12, border: "none",
              background: agreed ? RED : "#f0b5b5",
              color: "#fff", fontSize: 15, fontWeight: 700,
              cursor: agreed ? "pointer" : "not-allowed",
              transition: "background 0.15s ease",
            }}
          >
            Продолжить
          </button>
        </div>
      </div>
    </div>
  );
}

export function confirmVpnModal() {
  return new Promise((resolve) => {
    const host = document.createElement("div");
    document.body.appendChild(host);

    const root = createRoot(host);
    let resolved = false;
    const finish = (result) => {
      if (resolved) return;
      resolved = true;
      root.unmount();
      host.remove();
      resolve(result);
    };

    root.render(<VpnConfirmDialog onResult={finish} />);
  });
}